// @ts-ignore
import template from "./widget.html";
import css from "./widget.css";
import { openMenu } from "../menu/menu";
import translateWidget from "../menu/translateWidget";

import {
    pluginConfig
} from "@/globals/pluginConfig";

export let $widget: HTMLElement;

export function renderWidget() {
    $widget = document.createElement("div");
    $widget.classList.add("asw-container");
    $widget.innerHTML = `<style>${css}</style>${template}`;

    const { position = "bottom-left", offset = [20, 20], size = 58, color, stylesheet } = pluginConfig;
    const [offsetX = 20, offsetY = 20] = offset ?? [20, 20];
    const btnSize = size ?? 58;
    const iconSize = Math.round(btnSize * 36 / 58);

    $widget.dataset.aswPosition = position;
    $widget.style.setProperty('--asw-offset-x', `${offsetX}px`);
    $widget.style.setProperty('--asw-offset-y', `${offsetY}px`);
    $widget.style.setProperty('--asw-size', `${btnSize}px`);
    $widget.style.setProperty('--asw-icon-size', `${iconSize}px`);
    if (color) {
        $widget.style.setProperty('--asw-btn-color', color);
    }

    if (stylesheet) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = stylesheet;
        document.head.appendChild(link);
    }

    const $btn: HTMLElement = $widget.querySelector(".asw-menu-btn");
    $btn?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openMenu();
    });

    translateWidget();

    document.body.appendChild($widget);

    return $widget;
}


